import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/index.tsx';
import { IssueTypesView } from './main';
import { ResourceHandler } from './resource-handler';

export const IssueTypesDirectory = () => (
	<JSErrorBoundary
		id="issueTypesDirectory"
		packageName="jiraAdminPagesIssueTypesDirectory"
		teamName="morphinecake"
		sendToPrivacyUnsafeSplunk
	>
		<ResourceHandler />
		<IssueTypesView />
	</JSErrorBoundary>
);
